import { isProdClient } from '@/constants'

export const RR = {
  /**
   * Отправляет данные о просмотре категории/группы товара
   * @param {number} categoryId - ID категории
   */
  reportCategoryView: categoryId => {
    if (isProdClient) {
      ;(window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(function () {
        try {
          window.rrApi.categoryView(categoryId)
        } catch (e) {}
      })
    }
  },
  /**
   * Отправляет данные о просмотре конкретного товара
   * @param {number} productId - ID товара
   */
  reportProductView: productId => {
    if (isProdClient) {
      ;(window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(function () {
        try {
          window.rrApi.view(productId)
        } catch (e) {}
      })
    }
  },
  /**
   * Отправляет данные о добавлении товара в корзину
   * @param {number} productId - ID товара
   */
  reportAddToCart: productId => {
    if (isProdClient) {
      ;(window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(function () {
        try {
          window.rrApi.addToBasket(productId)
        } catch (e) {}
      })
    }
  },
  /**
   * Отправляет данные о созданном заказе
   * @param {number} orderId - ID заказа
   * @param {Array.<{id: Number, qnt: Number, price: Number}>} items - Информация о товарах
   */
  reportCreatedOrder: (orderId, items, customerInfo) => {
    if (isProdClient) {
      ;(window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(function () {
        try {
          window.rrApi.setCustomer(customerInfo)
          window.rrApi.order({
            transaction: orderId,
            items,
          })
        } catch (e) {}
      })
    }
  },
  /**
   * Отправляет базовые данные о пользователе для персонализации
   * @param {string} email - Email
   * @param {string} name - Имя
   */
  setUserInfo: (email, name) => {
    if (isProdClient) {
      ;(window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(function () {
        window.rrApi.setEmail(email, { name })
      })
    }
  },
}
